import React from "react";
import {
  FaBook,
  FaClipboardList,
  FaBusAlt,
  FaUserTie,
  FaUserAlt,
  FaRegCalendarTimes,
  FaBriefcase,
} from "react-icons/fa";
import {
  TbCreditCardPay,
  TbDashboard,
  TbNotebook,
  TbFileCertificate,
} from "react-icons/tb";
import { VscVmConnect } from "react-icons/vsc";
import { RiUserSettingsLine } from "react-icons/ri";
import { LuCalendarClock, LuUser } from "react-icons/lu";
import { HiOutlineCalculator, HiOutlineEye } from "react-icons/hi2";
import { BsFillCalendar2CheckFill } from "react-icons/bs";
import { GrUserWorker } from "react-icons/gr";
import { SiReadthedocs, SiTask } from "react-icons/si";
import { VscSaveAll } from "react-icons/vsc";
import { MdOutlineGppGood } from "react-icons/md";
import { VscRequestChanges } from "react-icons/vsc";
import {
  HiOutlineViewGrid,
  HiOutlineTrendingUp,
  HiOutlineMinusCircle,
} from "react-icons/hi";
import {
  MdOutlineBusinessCenter,
  MdOutlineCategory,
  MdOutlineInventory2,
  MdDirectionsBus,
  MdEmojiPeople,
  MdOutlineDirectionsBus,
  MdDirectionsCar,
} from "react-icons/md";
import { MdOutlineManageAccounts } from "react-icons/md";
import { ROLES } from "../../../config/permission";
import { BsCashCoin } from "react-icons/bs";
import { IoPeople } from "react-icons/io5";
import { RiHandCoinLine } from "react-icons/ri";
import { TfiReceipt } from "react-icons/tfi";
import { FaWpforms } from "react-icons/fa6";
import { GiCarrier, GiStabbedNote, GiSteeringWheel } from "react-icons/gi";
import { SiGoogleclassroom } from "react-icons/si";
import { ImFilesEmpty } from "react-icons/im";
import { VscGraph } from "react-icons/vsc";
import { AiOutlineMoneyCollect } from "react-icons/ai";
import { GiTakeMyMoney } from "react-icons/gi";

const sidebarData = [
  {
    title: "Dashboard",
    icon: <HiOutlineViewGrid />,

    path: `/dashboard`,
    roles: [
      ROLES.ADMIN,
      ROLES.TEACHER,
      ROLES.LIBRARIAN,
      ROLES.FINANCE,
      ROLES.STAFF,
    ],
    //requiredPermission: PERMISSIONS.VIEW_DASHBOARD, // Reference permission from config
  },
  {
    title: "Skill & Training",
    icon: <SiGoogleclassroom />,
    path: `/class`,
    roles: [ROLES.ADMIN, ROLES.TEACHER, ROLES.STAFF],
    //requiredPermission: PERMISSIONS.VIEW_CLASSES, // Added permission reference
  },
  {
    title: "Payroll",
    path: "/user-payroll",
    icon: <TbCreditCardPay />,
    roles: [ROLES.STAFF],
  },
  {
    title: "Applications",
    icon: <VscRequestChanges />,
    roles: [ROLES.STAFF],
    path: "/application_staff",
  },
  {
    title: "Visitor Management",
    icon: <IoPeople />,
    roles: [ROLES.ADMIN, ROLES.STAFF],
    path: "/visitor-management",
  },
  {
    title: "Project Management",
    icon: <SiTask />,
    path: "/project-management/tasks",
    roles: [ROLES.ADMIN, ROLES.STAFF],
  },
  {
    title: "Careers",
    icon: <FaBriefcase />,
    path: "/careers",
    roles: [ROLES.ADMIN, ROLES.STAFF],
  },
  {
    title: "Interviews",
    icon: <VscVmConnect />,
    path: "/interviews",
    roles: [ROLES.ADMIN, ROLES.STAFF],
  },
  {
    title: "Users",
    icon: <LuUser />,
    roles: [
      ROLES.ADMIN,
      ROLES.TEACHER,
      ROLES.FINANCE,
      ROLES.LIBRARIAN,
      ROLES.STAFF,
    ],
    items: [
      {
        title: "Manage Role",
        icon: <MdOutlineManageAccounts />,
        path: "/users/manage-roles",
        roles: [
          ROLES.ADMIN,
          ROLES.TEACHER,
          ROLES.FINANCE,
          ROLES.LIBRARIAN,
          ROLES.STAFF,
        ],
        //requiredPermission: PERMISSIONS.MANAGE_ROLES, // Added permission reference
      },

      {
        title: "Staff",
        icon: <GrUserWorker />,
        path: "/users/staffs",
        roles: [ROLES.ADMIN, ROLES.STAFF],
        //requiredPermission: PERMISSIONS.VIEW_STAFF, // Added permission reference
      },

      {
        title: "Driver",
        icon: (
          <span className="relative inline-block">
            <MdDirectionsCar className="text-xl" />
            <FaUserAlt className="absolute -end-2 -bottom-2 text-xs" />
          </span>
        ),
        path: "/users/driver",
        roles: [ROLES.ADMIN, ROLES.STAFF],
      },

      {
        title: "Helper",
        icon: (
          <span className="relative inline-block">
            <MdOutlineDirectionsBus className="text-xl" />
            <MdEmojiPeople className="absolute -end-2 -bottom-2 text-xs" />
          </span>
        ),
        path: "/users/helper",
        roles: [ROLES.ADMIN, ROLES.STAFF],
        //requiredPermission: PERMISSIONS.VIEW_LIBRARIANS, // Added permission reference
      },
    ],
  },

  {
    title: "HR Management",
    icon: <LuUser style={{ fontSize: "1.2rem" }} />,
    roles: [ROLES.ADMIN, ROLES.STAFF],
    items: [
      {
        title: "Benefits & Compensation",
        icon: <MdOutlineGppGood />,
        path: "/benifit-compensation",
        roles: [ROLES.ADMIN, ROLES.STAFF],
      },

      {
        title: "Certificates & Letter Management",
        icon: <TbFileCertificate />,
        path: "/certificates&lettermanagement",
        roles: [ROLES.ADMIN, ROLES.STAFF],
      },
      {
        title: "Document Management",
        icon: <ImFilesEmpty />,
        roles: [ROLES.ADMIN, ROLES.STAFF],
        path: "/document-management",
      },

      {
        title: "Staff Attendance",
        icon: <BsFillCalendar2CheckFill size={15} />,
        roles: [ROLES.ADMIN, ROLES.STAFF],
        path: "/Staff-Attendance",
      },
    ],
  },

  {
    title: "Communication",
    icon: <TbNotebook />,
    roles: [ROLES.ADMIN, ROLES.STAFF],
    items: [
      {
        title: "Notices",
        icon: <FaClipboardList />,
        path: "/noticeboard/notice",
        roles: [ROLES.ADMIN, ROLES.STAFF],
      },
      {
        title: "Calendar",
        icon: <FaBook />,
        path: "/noticeboard/events",
        roles: [ROLES.ADMIN, ROLES.STAFF],
      },
    ],
  },

  {
    title: `Finance & Assets`,
    icon: <HiOutlineCalculator />,
    roles: [ROLES.ADMIN, ROLES.STAFF],
    items: [
      {
        title: "Overview",
        path: "/finance/overview",
        icon: <HiOutlineViewGrid />,
        roles: [ROLES.ADMIN, ROLES.FINANCE, ROLES.STAFF],
      },
      {
        title: "Categories",
        path: "/finance/categories",
        icon: <MdOutlineCategory />,
        roles: [ROLES.ADMIN, ROLES.STAFF],
      },
      {
        title: "Inventory",
        path: "/finance/Inventory",
        icon: <MdOutlineInventory2 />,
        roles: [ROLES.ADMIN, ROLES.STAFF],
      },

      {
        title: "Entities",
        path: "/finance/entities",
        icon: <MdOutlineBusinessCenter />,
        roles: [ROLES.ADMIN, ROLES.STAFF],
      },
      {
        title: "Entity Revenue",
        icon: <BsCashCoin />,
        path: "/finance/entity/revenue",
        roles: [ROLES.ADMIN, ROLES.STAFF],
      },

      {
        title: "Receipts",
        path: "/finance/receipts",
        icon: <TfiReceipt />,
        roles: [ROLES.ADMIN, ROLES.STAFF],
      },

      {
        title: "Operational Expenses",
        path: "/finance/operational-expenses",
        icon: <RiHandCoinLine />,
        roles: [ROLES.ADMIN, ROLES.STAFF],
      },
      {
        title: "Payroll",
        path: "/finance/payroll",
        icon: <TbCreditCardPay />,
        roles: [ROLES.ADMIN, ROLES.STAFF],
      },

      {
        title: "Quotations",
        path: "/finance/quotations",
        icon: <FaWpforms />,
        roles: [ROLES.ADMIN, ROLES.STAFF],
      },
      {
        title: "Budget Planner",
        path: "/finance/budget-planner",
        icon: <GiStabbedNote />,
        roles: [ROLES.ADMIN, ROLES.STAFF],
      },
      {
        title: "Day Book",
        path: "/finance/day-book",
        icon: <GiStabbedNote />,
        roles: [ROLES.ADMIN, ROLES.STAFF],
        //requiredPermission: PERMISSIONS.VIEW_PENALTIES,
      },
      {
        title: "Bank Reconciliation",
        path: "/finance/bank-reconciliation",
        icon: <SiReadthedocs />,
        roles: [ROLES.ADMIN, ROLES.STAFF],
        //requiredPermission: PERMISSIONS.VIEW_PENALTIES,
      },
      {
        title: "Finance Configuration",
        path: "/finance/configuration",
        icon: <VscSaveAll />,
        roles: [ROLES.ADMIN, ROLES.STAFF],
        //requiredPermission: PERMISSIONS.VIEW_PENALTIES,
      },
      {
        title: "Penalties",
        path: "/finance/penalties",
        icon: <FaRegCalendarTimes />,
        roles: [ROLES.ADMIN, ROLES.STAFF],
        //requiredPermission: PERMISSIONS.VIEW_PENALTIES,
      },
      {
        title: "Share Holders",
        path: "/finance/investment",
        icon: <HiOutlineTrendingUp />,
        roles: [ROLES.ADMIN, ROLES.FINANCE, ROLES.STAFF],
      },
      {
        title: "Liabilities",
        path: "/finance/liabilities",
        icon: <HiOutlineMinusCircle />,
        roles: [ROLES.ADMIN, ROLES.FINANCE, ROLES.STAFF],
      },
      {
        title: "Fixed Assets",
        path: "/finance/assets",
        icon: <AiOutlineMoneyCollect />,
        roles: [ROLES.ADMIN, ROLES.FINANCE, ROLES.STAFF],
      },
      {
        title: "Vouchers",
        path: "/finance/vouchers",
        icon: <GiTakeMyMoney />,
        roles: [ROLES.ADMIN, ROLES.FINANCE, ROLES.STAFF],
      },
      {
        title: "Financial Statements",
        path: "/finance/statements",
        icon: <VscGraph />,
        roles: [ROLES.ADMIN, ROLES.FINANCE, ROLES.STAFF],
      },
    ],
  },
  // Transportation Module - New Addition
  {
    title: "Transportation",
    icon: <FaBusAlt />,
    roles: [ROLES.ADMIN, ROLES.STAFF],
    items: [
      {
        title: "Vehicle Schedule", // New tab
        icon: <LuCalendarClock />, // You can choose a different icon if preferred
        path: "/transportation/schedule",
        roles: [ROLES.ADMIN, ROLES.STAFF],
      },
      {
        title: "Shift Management", // New tab
        icon: <RiUserSettingsLine />, // You can choose a different icon if preferred
        path: "/transportation/shift-management",
        roles: [ROLES.ADMIN, ROLES.STAFF],
      },
      {
        title: "Vehicle Management", // New tab
        icon: <MdDirectionsBus />, // You can choose a different icon if preferred
        path: "/transportation/vehicle-management",
        roles: [ROLES.ADMIN, ROLES.STAFF],
      },

      {
        title: "Driver Management",
        icon: <FaUserTie />,
        path: "/transportation/driver-staff",
        roles: [ROLES.ADMIN, ROLES.STAFF],
      },
      {
        title: "Driver Assignment",
        icon: <GiSteeringWheel />,
        path: "/transportation/driver-vehicle-assignment",
        roles: [ROLES.ADMIN, ROLES.STAFF],
      },
      {
        title: "Route Management",
        icon: <MdDirectionsBus />,
        path: "/transportation/route-management",
        roles: [ROLES.ADMIN, ROLES.STAFF],
      },
      {
        title: "Live Tracking",
        icon: <HiOutlineEye />,
        path: "/transportation/live-tracking",
        roles: [ROLES.ADMIN, ROLES.STAFF],
      },
    ],
  },
];

export default sidebarData;
